/**
 * 获取考试界面模拟数据
 */
export function getinitExamData() {
    return [{
        type: "0", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "1",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: "",
            questionId: "",
            isCollect: true, // 是否收藏
            collectId: ""
        }, {
            index: "2",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "3",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "4",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "5",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "6",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "7",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "A",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }]
    }, {
        type: "1", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "8",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "9",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "10",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "11",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "12",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "13",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "14",
            questionStem: "题干题干",
            questionOptions: [
                // 选择题的选择项组
                { title: "A", value: "AAAA" },
                { title: "B", value: "BBBB" },
            ],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }]
    }, {
        type: "2", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "15",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "16",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "17",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "18",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: [],
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, ]
    }, {
        type: "3", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "19",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "20",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "21",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "22",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 4,
            points: "2",
            answer: "",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, ]
    }, {
        type: "4", // 0 单选  1 多选  2 填空  3 判断  4 简答
        typeTotalPoints: "20",
        item: [{
            index: "23",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "24",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "25",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, {
            index: "26",
            questionStem: "<p>恩爱大V时违反过<span class=\"gapfilling-span e29a18d9-dc6d-44a8-9808-7e2dd5c7b022\">1</span>隔壁<span class=\"gapfilling-span 699df226-58b8-4eba-a8dd-9ac65e817748\">2</span>达芙文<span class=\"gapfilling-span e6e9e8a7-3b37-4c9b-9791-95970c17f610\">3</span>去按顺序A</p>",
            questionOptions: [],
            gradeOfDifficulty: 1,
            points: "2",
            answer: "",
            grade: "",
            questionId: "",
            isCollect: false, // 是否收藏
            collectId: ""
        }, ]
    }, ]
}


/**
 * 小写数字转大写数字
 */
export function transitionNumToText(num) {
    let text = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
    return text[num];
}

/**
 * 获取列表界面的搜索项
 */
export function getSearchData(flag) {
    let data = []
    switch (flag) {
        case "err":
            // 错题集
            data = [{
                title: "科目",
                type: "selects",
                value: [],
                key: "subject",
                options: []
            }, ]
            break;
        case "collect":
            // 收藏夹
            data = [{
                title: "科目",
                type: "selects",
                value: [],
                key: "subject",
                options: []
            }, ]
            break;

        default:
            break;
    }
    return data
}

/**
 * 获取表格表头数据
 */
export function getTableMenu(flag) {
    let data = []
    switch (flag) {
        case "err":
            // 错题集
            data = [
                { name: "题干", key: "questionName", isStar: false, isHtml: true, width: 830 },
                { name: "添加时间", key: "time", isStar: false, isHtml: false },
            ]
            break;
        case "collect":
            // 收藏夹
            data = [
                { name: "题干", key: "questionName", isStar: false, isHtml: true, width: 830 },
                { name: "添加时间", key: "time", isStar: false, isHtml: false },
            ]
            break;

        default:
            break;
    }
    return data
}

/**
 * 获取表格操作按钮
 */
export function getTableBUttonList(flag) {
    let data = []
    switch (flag) {
        case "err":
            // 错题集
            data = [
                { text: "查看", active: "show" },
                { text: "移除", active: "remove" },
            ]
            break;
        case "collect":
            // 收藏夹
            data = [
                { text: "查看", active: "show" },
                { text: "取消收藏", active: "remove" },
            ]
            break;

        default:
            break;
    }
    return data
}